import type { GuideContext } from '../engine';

function isCompany(ctx: GuideContext): boolean {
  return ctx.customerKind === 'company';
}

/** Where to go once the vehicle slot no longer needs its own stop. */
export function afterVehicle(ctx: GuideContext): string {
  if (ctx.isNewCustomer === true) return isCompany(ctx) ? 'newCompany' : 'newPerson';
  if (isCompany(ctx)) return 'companyContact';
  return 'leaveCustomer';
}

/** Search is done: visit a new vehicle before the customer fields. */
export function afterCustomerResolved(ctx: GuideContext): string {
  if (ctx.isNewVehicle === true) return 'newVehicle';
  return afterVehicle(ctx);
}
